import React from 'react';
import { createElement } from 'react';
import { getclassnames } from './getClassName';
import arrowIcon from './images/right@3x.png';
import titlePic from './images/i-icon-@2x.png';
import './style.less';
class Selection extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            value: this.props.value,
        };
        this.onChange = e => {
            e.preventDefault();
            e.stopPropagation();
            this.setState({
                value: e.target.value,
            });
        };
        this.onClick = e => {
            e.preventDefault();
            this.props.onClick?.();
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value !== prevState.value) {
            return { value: nextProps.value };
        }
        return null;
    }
    render() {
        const { title, titleWidth, titleDescription, placeholder, inputDescription, disabled, inputDescStyle, arrow, hidebottomline, showTitleIcon, titleIconSrc, titleIconFunc, isTitleUp, inputAriaLabel, error } = this.props;
        const prefixCls = 'im-selection';
        const { arrowIconCls, titleDesc, inputDesc, titleLeft, titleWarp, inputWarp } = getclassnames({
            titleDescription,
            inputDescription,
            arrow,
            prefixCls,
            isTitleUp
        });
        const _titleIconFunc = (e) => {
            e.stopPropagation();
            titleIconFunc?.();
        };
        return (createElement("div", { className: `${prefixCls}`, onClick: disabled ? undefined : this.onClick },
            createElement("div", { className: titleLeft },
                title && createElement("div", { className: titleWarp, "aria-label": title, style: { width: titleWidth } },
                    createElement("div", { className: `${prefixCls}-container-left-title` }, title),
                    showTitleIcon && titleIconSrc && (createElement("img", { className: `${prefixCls}-container-left-titleIcon`, onClick: _titleIconFunc, src: titleIconSrc, alt: "" }))),
                createElement("div", { className: inputWarp, tabIndex: 0, "aria-label": inputAriaLabel ? inputAriaLabel : placeholder },
                    createElement("div", { className: `${prefixCls}-container-input`, tabIndex: -1 },
                        createElement("input", { type: "text", tabIndex: -1, value: this.state.value, onChange: this.onChange, disabled: disabled, placeholder: placeholder, role: "group" })),
                    createElement("div", { className: `${prefixCls}-container-arrow` },
                        createElement("img", { src: arrowIcon, className: arrowIconCls, alt: "" }))),
                error && isTitleUp && createElement("div", { className: `${prefixCls}-error` }, error)),
            createElement("div", { className: `${prefixCls}-desc` },
                titleDescription ? (createElement("div", { className: titleDesc }, titleDescription)) : null,
                inputDescription ? (createElement("div", { className: inputDesc, style: inputDescStyle }, inputDescription)) : null,
                error && !isTitleUp && createElement("div", { className: `${prefixCls}-desc-error` }, error)),
            Boolean(!hidebottomline) && (createElement("div", { className: `${prefixCls}-bottomLine` }))));
    }
}
Selection.defaultProps = {
    placeholder: '请输入内容',
    arrow: 'right',
    hidebottomline: true,
    showTitleIcon: false,
    titleIconSrc: titlePic,
};
export default Selection;
export { SelectionPropsType } from './PropsType';
